import React from 'react';
import { EventAvailable, LockOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { AccountData, OrderData, ReschedulePolicyData } from '../../api';
import { GhostLink } from './GhostButton';
import { InfoTiles, orderToInfoTiles } from './InfoTiles';
import { Notice } from './Notice';

export enum RescheduleBlockReason {
  WINDOW_PASSED = 'rescheduleWindowPassed',
  ALREADY_STARTED = 'orderAlreadyStarted',
  SELF_SERVE_DISABLED = 'selfServeRescheduleDisabled',
  GROUP_SIZE = 'rescheduleNotAllowedForGroupSize',
}

type BlockedStateProps = {
  reason: string;
  order: OrderData;
  account: AccountData;
  reschedulePolicy?: ReschedulePolicyData;
};

export const BlockedState = ({ reason, order, account, reschedulePolicy }: BlockedStateProps) => {
  const { t } = useTranslation();
  const phone = account.business_details?.contact?.phone;

  const phoneLink = phone ? (
    <GhostLink href={`tel:${phone}`}>{t('manage_booking.v2.callBusiness', { phone })}</GhostLink>
  ) : null;

  let notice = (
    <Notice
      variant="info"
      title={t('manage_booking.v2.blockedNotAllowedTitle')}
      body={t(
        reason === RescheduleBlockReason.SELF_SERVE_DISABLED
          ? 'manage_booking.v2.blockedDisabledBody'
          : 'manage_booking.v2.blockedNotAllowedBody',
      )}
    />
  );
  let action = phoneLink;

  if (reason === RescheduleBlockReason.WINDOW_PASSED) {
    notice = (
      <Notice
        variant="info"
        icon={<LockOutlined />}
        title={t('manage_booking.v2.blockedClosedTitle')}
        body={t('manage_booking.v2.blockedClosedBody', { h: reschedulePolicy?.min_hours_before ?? 0 })}
      />
    );
  } else if (reason === RescheduleBlockReason.GROUP_SIZE) {
    notice = (
      <Notice
        variant="info"
        title={t('manage_booking.v2.blockedNotAllowedTitle')}
        body={t('manage_booking.v2.blockedGroupSizeBody', { n: reschedulePolicy?.max_persons ?? 0 })}
      />
    );
  } else if (reason === RescheduleBlockReason.ALREADY_STARTED) {
    notice = (
      <Notice
        variant="info"
        icon={<EventAvailable />}
        title={t('manage_booking.v2.blockedStartedTitle')}
        body={t('manage_booking.v2.blockedStartedBody')}
      />
    );
    action = null;
  }

  return (
    <>
      <InfoTiles {...orderToInfoTiles(order, t)} />
      {notice}
      {action}
    </>
  );
};
